module.exports = __webpack_public_path__ + "static/logo-light-mobil-2e4019ea7c524dc654ee1064ff3bdd1f.png";